import { IDropdownFilterUI } from '../../common/utils/types';
import { IFormFieldWithLabel } from './formFields';

export enum EMyHomeEstimationTargets {
  flat,
  house,
  land,
}

export type TEstimationTargetProps = IDropdownFilterUI<EMyHomeEstimationTargets> & IFormFieldWithLabel;
